import React from 'react';
import './Privacy.css';

export const Privacy: React.FC = (props => {
  return (
    <div className={'content'}>
      Iodine Softwares (including Iodine Code / Iodine Poker / Iodine MySQL / Iodine Ludo) collect anonymous data only for crashlytics and performance analyse, the data will not be connect to your identity.
    </div>
  );
})